import { render, staticRenderFns } from "./addSensitive.vue?vue&type=template&id=f9f96252&scoped=true&"
import script from "./addSensitive.vue?vue&type=script&lang=js&"
export * from "./addSensitive.vue?vue&type=script&lang=js&"
import style0 from "./addSensitive.vue?vue&type=style&index=0&id=f9f96252&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f96252",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9f96252')) {
      api.createRecord('f9f96252', component.options)
    } else {
      api.reload('f9f96252', component.options)
    }
    module.hot.accept("./addSensitive.vue?vue&type=template&id=f9f96252&scoped=true&", function () {
      api.rerender('f9f96252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/SenWordSettings/addSensitive.vue"
export default component.exports